import { mediaUrl } from "@/lib/api";

const Concept = ({ vc }) => {
  const src = mediaUrl(vc.mockup_image_url);
  return (
    <div className="iv-glass flex min-w-0 items-center gap-3 rounded-xl p-2.5" data-testid={`concept-card-${vc.is_safe_pivot_preview ? "pivot" : "primary"}`}>
      {src ? (
        <img src={src} alt={`3D visual concept for ${vc.brand_name}: ${vc.tagline}`} loading="lazy" width="72" height="72" className="h-[72px] w-[72px] shrink-0 rounded-lg object-cover" />
      ) : (
        <div className="grid h-[72px] w-[72px] shrink-0 place-items-center rounded-lg bg-white/[0.04] text-center text-[9px] text-slate-500 animate-pulse">Rendering 3D concept</div>
      )}
      <div className="min-w-0">
        <div className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">{vc.is_safe_pivot_preview ? "Safe Pivot Concept" : "3D Visual Concept"}</div>
        <div className="truncate text-sm font-bold text-white">{vc.brand_name}</div>
        <div className="line-clamp-2 text-[11px] text-slate-400">{vc.tagline}</div>
      </div>
    </div>
  );
};

export const ConceptStrip = ({ report }) => {
  const visuals = report?.visual_concepts ?? [];
  if (!visuals.length) return null;
  return (
    <div className={`grid gap-2 ${visuals.length > 1 ? "sm:grid-cols-2" : ""}`} data-testid="concept-strip">
      {visuals.map((vc) => <Concept key={vc.id} vc={vc} />)}
    </div>
  );
};
